import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PromotionFloatingActionBarProps {
    mode: 'create' | 'update'
    isDirty: boolean
    isPending: boolean
    shake: boolean
    onReset: () => void
    onSubmit: () => void
}

export const PromotionFloatingActionBar = ({
    mode,
    isDirty,
    isPending,
    shake,
    onReset,
    onSubmit,
}: PromotionFloatingActionBarProps) => {
    const { t } = useTranslation('stores')

    if (!isDirty) return null

    const primaryLabel = isPending
        ? mode === 'create'
            ? t('promotion.actions.creating')
            : t('promotion.actions.saving')
        : mode === 'create'
            ? t('promotion.actions.create')
            : t('promotion.actions.saveChanges')

    return (
        <div className="pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4">
            <div
                className={cn(
                    'bg-background pointer-events-auto flex items-center gap-2 rounded-full border px-3 py-2 shadow-lg',
                    shake && 'animate-[attentionShake_0.7s_ease-in-out]',
                )}
            >
                <Button type="button" variant="ghost" size="sm" onClick={onReset}>
                    {t('promotion.actions.discard')}
                </Button>
                <Button type="submit" size="sm" disabled={isPending} onClick={onSubmit}>
                    {primaryLabel}
                </Button>
            </div>
        </div>
    )
}
